import { useTranslation } from 'react-i18next'
import styles from './VoterMyProfile.module.scss'

export const VoterMyProfile = () => {
  const { t } = useTranslation()

  return (
    <div className={styles['container']}>
      <h1 className={styles['header']}>{t('pages.myProfile')}</h1>
    </div>
  )
}
